import UploadedBalanceReportList from './UploadedBalanceReportList';
import { CustomPageHeader, Text } from '@src/components';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

const UploadedBalanceReport = ({ isCompliments = false, isMarket = false }) => {
  const routesTitle = useMemo(() => {
    if (isMarket) return 'Ticket Market';
    if (isCompliments) return 'Ticket Gift';
    return 'Ticket Restaurant';
  }, [isMarket, isCompliments]);

  return (
    <CustomPageHeader
      data-testid="uploaded-balance-report"
      title={<Text t="loadedBalanceReport" />}
      showBreadCrumb
      showHelpButton
      routes={[routesTitle, 'Raporlar']}
    >
      <UploadedBalanceReportList isCompliments={isCompliments} isMarket={isMarket} />
    </CustomPageHeader>
  );
};

UploadedBalanceReport.propTypes = {
  isCompliments: PropTypes.bool,
  isMarket: PropTypes.bool,
};
export default UploadedBalanceReport;
